import { Description, Field, Input, Label } from '@headlessui/react';
import clsx from 'clsx';
import FormError from '@components/forms/common/FormError.component.jsx';

function FormInput({
  ref,
  label,
  description,
  name,
  value,
  onChange,
  onFocus,
  error,
}) {
  return (
    <Field ref={ref}>
      <Label className="text-base font-semibold text-event-light">
        {label}
      </Label>
      <Description as="p" className="text-base font-semibold text-event-muted">
        {description}
      </Description>
      <Input
        onChange={onChange}
        value={value}
        onFocus={onFocus}
        className={clsx(
          'block w-full resize-none rounded-lg border border-spacing-2 mt-1 py-1.5 px-3 text-sm/6 text-white scroll-m-32',
          'focus:outline-none focus:border-event-tertiary focus:bg-event-light/10 data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25',
          {
            'border-event-muted bg-event-light/7': !error,
            'border-event-primary bg-event-light/7': error,
          },
        )}
        name={name}
      />
      {error && <FormError className="mt-1" error={error} />}
    </Field>
  );
}

FormInput.propTypes = {};
export default FormInput;
